import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import Multiselect from 'vue-multiselect'
import Pagination from './../shared/pagination'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs';

export default {
	name: 'pincodemapping',
	components: {
		Pagination,
		Loader,
		Multiselect
	},
	data: function() {
		return {
			isLoading: false,
			uploadErr: '',
			listWarehouseData: [],
			warehouseError: '',
			warehouse: '',
			user_type: '',
			showWarehouseFilter: false,
			destinationPinCode: '',
			courierPartner: '',
			totalrows: 0,
			totalPage: 0,
			pageLimit: 10,
			currentPage: 1,
			mappingDataList: [],
			addMappingModal: false,
			warehouseModal: '',
			file: '',
			csvFields: [],
			userEmail: '',
			is_Loading: false,
			isFailureRecords: false,
			failureRecords: [],
			csvDataAllow: 0,
			formattedDate: '',
			showDownloadType: false,
			dataFilter2: '',
			mappingDataforxls: [],
			reportname: '',
			csvFieldsForXls: {},
			showCSVForm: false,
			showManualForm: false,
			warehouseManual: '',
			warehouseManualError: '',
			destinationPinCodeManual: '',
			destinationPinCodeManualError: '',
			courierPartnerManual: '',
			courierPartnerManualError: '',
			tatInDaysManual: '',
			tatInDaysManualError: '',
			changestatus: '',
			modalShow: false,
			modalstatus: '',
			modalId: ''
		}
	},
	created: function() {},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.pincodeMappingReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;

		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.userEmail = userdetail.email;
		switch (this.user_type) {
			case 'system_user':
				this.showWarehouseFilter = true
				// this.getWarehouseList()
				break;

			case 'client_user':
				this.showWarehouseFilter = true
				// this.getWarehouseList()
				break;

			case 'warehouse_user':
				this.warehouse = userdetail.warehouseid;
				this.warehouseModal = userdetail.warehouseid;
				this.warehouseManual = userdetail.warehouseid;
				this.searchFilter()
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break;
		}

	},
	computed: {

	},
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		// warehouseSelected() {
		// 	this.currentPage = 1;
		// 	if (this.warehouse) {
		// 		this.warehouseError = ''

		// 	}
		// },
		// async getWarehouseList() {
		// 	try {
		// 		this.isLoading = true
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '')
		// 		let result = await axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': {},
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		this.listWarehouseData = result.data.data
		// 		this.isLoading = false
		// 	} catch (err) {
		// 		console.log(err);
		// 	}
		// },
		async searchFilter(obj = 0) {
			try {
				if (obj == 0) {
					this.showDownloadType = false
				}
				this.csvDataAllow = obj
				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
				this.isLoading = true
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				this.input = ({
					warehouseid: localStorage.getItem("selectedWarehouse"),
					destinationpincode: this.destinationPinCode,
					courierpartner: this.courierPartner,
					limit: this.pageLimit,
					offset: (this.currentPage - 1) * this.pageLimit,
					csvdata: this.csvDataAllow
				})
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getMappingPinCodeDataForWarehouse',
					'data': this.input,
					'headers': {
						'Authorization': 'Bearer ' + myStr
					}
				})
				if (this.csvDataAllow == 1) {
					var dataFilter = {};
					Object.entries(this.input).forEach(([k, v]) => {
						let skipkeys = ['offset', 'limit', 'csvdata'];
						if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
							dataFilter[k] = v;
						}
					})
					if (result.data.csvdata.length > 0) {
						let csvFields = {
							'warehousename': this.$t('warehouses.warehouseName'),
							'warehouseid': this.$t('warehouses.warehouseID'),
							'sourcepincode': this.$t('pincodemapping.sourcePinCode'),
							'destinationpincode': this.$t('pincodemapping.destinationPinCode'),
							'courierpartner': this.$t('pincodemapping.courierPartner'),
							'tatindays': this.$t('pincodemapping.TAT'),
							'createdby': this.$t('pincodemapping.createBy'),
							'createddate': this.$t('pincodemapping.createdDate'),
							'updatedby': this.$t('pincodemapping.updatedBy'),
							'updateddate': this.$t('pincodemapping.updateDate'),
						}
						var dateFilder = ['createddate', 'updateddate'];
						var skipFilter = [];
						let csvMappingData = result.data.csvdata
						this.jsonToCSVNew(this.$t('editedjson.pincodeMappingReport'), csvMappingData, csvFields, dateFilder, skipFilter, dataFilter);
					} else {
						this.$alertify.error(this.$t('srReport.dataNotFound'));
					}
				} else {
					this.mappingDataList = result.data.rows
					this.totalrows = result.data.count;
					if (this.totalrows < this.pageLimit) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalrows / this.pageLimit);
					}
				}
				this.isLoading = false
			} catch (err) {
				console.log(err);
			}
		},
		jsonToCSVNew(filename, data, csvfield, dateFilder = [], skipFilter = [], dataFilter = {}) {
			var csvData = ''
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ','
			}
			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		},

		resetFilter() {
			if (this.showWarehouseFilter) {
				this.warehouse = ''
			}
			this.warehouseError = ''
			this.destinationPinCode = ''
			this.courierPartner = ''
			this.totalrows = 0
			this.mappingDataList = []
			this.isLoading = false
			this.csvDataAllow = 0
			this.showDownloadType = false
			this.mappingDataforxls = []
		},

		onPageChange(page) {
			this.currentPage = page;
			this.searchFilter()
		},

		addNewMapping() {
			this.resetAddForm()
			this.addMappingModal = true
			this.showCSVForm = false
			this.showManualForm = false
		},

		downloadCsvFormat() {
			this.csvFields = [{
					'fieldIndex': 0,
					'fieldColumn': 'destinationpincode',
					'fieldName': this.$t('pincodemapping.destinationPinCode')
				},
				{
					'fieldIndex': 1,
					'fieldColumn': 'tatindays',
					'fieldName': this.$t('pincodemapping.TAT')
				},
				{
					'fieldIndex': 2,
					'fieldColumn': 'courierpartner',
					'fieldName': this.$t('pincodemapping.courierPartner')
				}
			]
			let test = []
			var dateFilder = [];
			var skipFilter = [];
			this.jsonToCSV(this.$t('editedjson.mappingData'), [], this.csvFields, dateFilder, skipFilter);
		},

		resetAddForm() {
			if (this.showWarehouseFilter) {
				this.warehouseModal = ''
			}
			this.file = ''
			this.is_Loading = false
			this.isFailureRecords = false
			this.failureRecords = []
			this.$validator.reset()
		},

		saveAddModal() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.submitFile()
					return false;
				} else {
					return false;
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},

		async submitFile() {
			try {
				if (localStorage.getItem("selectedWarehouse") == '') {
					this.warehouseManualError = this.$t('common.warehouseError');
				}

				if (this.file == '' || (this.$refs.file.files[0].type != 'text/csv' && this.$refs.file.files[0].type != 'application/vnd.ms-excel')) {
					let uploadFileExtension = this.$refs.file.files[0];
					if(!this.file || this.file == ''){
						this.uploadErr = this.$t('pincodemapping.uploadMappingError');
					}
					if (/\.(csv|ms-excel|CSV)$/i.test(uploadFileExtension.name)) {
						console.log(uploadFileExtension.name, "=====================Valid Extension====================");
					} else {
						this.$alertify.error(this.$t('productLogReport.selectCSVFile'));
					

						return false;
						console.log(uploadFileExtension.name, "=====================InValid Extension====================");
					}
				}
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.is_Loading = true
				var formData = new FormData();
				formData.append('csv', this.file);
				formData.append('createdby', this.userEmail);
				formData.append('warehouseid', localStorage.getItem("selectedWarehouse"));
				let result = await axios.post(apiUrl.api_url + 'loadPinCodeMappingForWarehouse',
					formData, {
						headers: {
							'Authorization': 'Bearer ' + myStr,
							'Content-Type': 'multipart/form-data'
						}
					})
				if (result.data.errorCode == 0) {
					if (result.data.isFailure) {
						this.$alertify.success(result.data.msg)
						this.isFailureRecords = true
						this.failureRecords = result.data.failurerecords
						this.is_Loading = false
					} else {
						this.addMappingModal = false
						this.$alertify.success(result.data.msg)
						this.currentPage = 1
						this.resetFilter()
						if (!this.showWarehouseFilter) {
							this.searchFilter()
						}
					}
				} else {
					this.$alertify.error(result.data.msg)
					return false
				}
				this.is_Loading = false
			} catch (err) {
				console.log(err);
			}
		},
		downloadRejectedRows() {
			this.csvFields = [{
					'fieldIndex': 0,
					'fieldColumn': 'destinationpincode',
					'fieldName': this.$t('pincodemapping.destinationPinCode')
				},
				{
					'fieldIndex': 1,
					'fieldColumn': 'tatindays',
					'fieldName': this.$t('pincodemapping.TAT')
				},
				{
					'fieldIndex': 2,
					'fieldColumn': 'courierpartner',
					'fieldName': this.$t('pincodemapping.courierPartner')
				},
				{
					'fieldIndex': 3,
					'fieldColumn': 'failurereason',
					'fieldName': this.$t('editedjson.failureReason')
				}
			]
			let csvDataRejected = []
			this.failureRecords.forEach((el) => {
				csvDataRejected.push({
					destinationpincode: el.data.destinationpincode,
					tatindays: el.data.tatindays,
					courierpartner: el.data.courierpartner,
					failurereason: el.msg
				})
			})
			let test = []
			var dateFilder = [];
			var skipFilter = [];
			this.jsonToCSV(this.$t('editedjson.failedMappingData'), csvDataRejected, this.csvFields, dateFilder, skipFilter);
		},

		handleFileUpload() {
			this.file = this.$refs.file.files[0];
			if(!this.file){
				this.uploadErr = this.$t('pincodemapping.uploadMappingError');
			}
		},

		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
			var csvData = ''
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			csvfield.forEach(function(fields) {
				if (skipFilter.indexOf(fields.fieldColumn) == -1) {
					csvData += fields.fieldName + ','
				}
			});
			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			data.map(function(item) {
				var i = 0;
				var escapedCSV = ''
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						escapedCSV = item[key] + '' // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
					i++;
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		selectDownloadType() {
			this.getDataForXls()
			this.showDownloadType = true
		},

		async getDataForXls() {
			try {
				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
				this.isLoading = true
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				this.dataFilter2 = []
				var value = ''
				var str = ''
				this.mappingDataforxls = []
				this.input = ({
					warehouseid: localStorage.getItem("selectedWarehouse"),
					destinationpincode: this.destinationPinCode,
					courierpartner: this.courierPartner,
					limit: this.pageLimit,
					offset: (this.currentPage - 1) * this.pageLimit,
					csvdata: 1
				})
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getMappingPinCodeDataForWarehouse',
					'data': this.input,
					'headers': {
						'Authorization': 'Bearer ' + myStr
					}
				})
				Object.entries(this.input).forEach(([k, v]) => {
					let skipkeys = ['offset', 'limit', 'csvdata'];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						value += k + ':' + v + ','
						this.dataFilter2 = str.concat(value);

					}
				})
				if (result.data.csvdata.length > 0) {
					this.csvFieldsForXls[this.$t('warehouses.warehouseName')]= 'warehousename';
					this.csvFieldsForXls[this.$t('warehouses.warehouseID')]= 'warehouseid';
					this.csvFieldsForXls[this.$t('pincodemapping.sourcePinCode')]= 'sourcepincode';
					this.csvFieldsForXls[this.$t('pincodemapping.destinationPinCode')]= 'destinationpincode';
					this.csvFieldsForXls[this.$t('pincodemapping.courierPartner')]= 'courierpartner';
					this.csvFieldsForXls[this.$t('pincodemapping.createBy')]= 'createdby';
					this.csvFieldsForXls[this.$t('pincodemapping.createdDate')]= 'createddate';
					this.csvFieldsForXls[this.$t('pincodemapping.updatedBy')]= 'updatedby';
					this.csvFieldsForXls[this.$t('pincodemapping.updateDate')]= 'updateddate';
					var dateFilder = ['createddate', 'updateddate'];
					var skipFilter = [];
					var dataFilter = {};
					this.mappingDataforxls = result.data.csvdata
				} else {
					this.$alertify.error(this.$t('srReport.dataNotFound'));
				}
				this.isLoading = false
			} catch (err) {
				console.log(err);
			}
		},
		startDownload() {
			this.isLoading = true;
		},
		finishDownload() {
			this.isLoading = false;
		},
		checkAddMappingType(obj) {
			if (obj == 'manual') {
				this.resetAddFormManual()
				this.showCSVForm = false
				this.showManualForm = true
			} else {
				this.showCSVForm = true
				this.showManualForm = false
				if (document.getElementById('file')) {
					document.getElementById('file').value = ''
				}
			}
		},
		async saveAddModalManual() {
			try {
				console.log(this.warehouseModal ,"==========");
				this.is_Loading = true
				this.file = this.$refs.file.files[0];
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'addUpdatePinCodeMapping',
					'data': {
						"warehouseid": localStorage.getItem("selectedWarehouse"),
						"destinationpincode": this.destinationPinCodeManual,
						"courierpartner": this.courierPartnerManual.trim(),
						"tatindays": this.tatInDaysManual,
						"createdby": this.userEmail
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				if (result.data.status) {
					this.addMappingModal = false
					this.$alertify.success(result.data.msg)
					this.currentPage = 1
					this.resetFilter()
					if (!this.showWarehouseFilter) {
						this.searchFilter()
					}
				} else {
					this.$alertify.error(result.data.msg)
				}
				this.is_Loading = false
			} catch (err) {
				console.log(err);
			}
		},
		checkAllFeilds(obj = 0) {
			if (!localStorage.getItem("selectedWarehouse") || localStorage.getItem("selectedWarehouse") == '') {
				this.warehouseManualError = this.$t('common.warehouseError');
				return false
			} else {
				this.warehouseManualError = ''
			}
			if (!this.destinationPinCodeManual || this.destinationPinCodeManual == '') {
				this.destinationPinCodeManualError = this.$t('pincodemapping.destinationPinCodeError');
				return false
			} else {
				this.destinationPinCodeManualError = ''
			}
			if (!this.courierPartnerManual || this.courierPartnerManual == '') {
				this.courierPartnerManualError = this.$t('pincodemapping.courierPartnerError');
				return false
			} else {
				this.courierPartnerManualError = ''
			}
			if (!this.tatInDaysManual || this.tatInDaysManual == '') {
				this.tatInDaysManualError = this.$t('pincodemapping.tatError');
				return false
			} else {
				this.tatInDaysManualError = ''
			}
			if (Number(this.tatInDaysManual) <= 0) {
				this.$alertify.error("TAT Must Be Greator Than 0")
				this.tatInDaysManual = ''
				return false
			}
			if (Number(this.destinationPinCodeManual) <= 0) {
				this.$alertify.error("InValid Destination PinCode")
				this.destinationPinCodeManual = ''
				return false
			}
			if (obj == 1) {
				this.saveAddModalManual()
			}
		},
		resetAddFormManual() {
			if (this.showWarehouseFilter) {
				this.warehouseManual = ''
			}
			this.warehouseManualError = ''
			this.destinationPinCodeManual = ''
			this.destinationPinCodeManualError = ''
			this.courierPartnerManual = ''
			this.courierPartnerManualError = ''
			this.tatInDaysManual = ''
			this.tatInDaysManualError = ''
		},
		getStatusRowData(data) {
			this.modalShow = true
			this.modalId = data.id
			if (data.status == 0) {
				this.changestatus = 'Active'
				this.modalstatus = 1
			} else {
				this.changestatus = 'Inactive'
				this.modalstatus = 0
			}
			this.modalShow = true
		},
		closeStatusUserModal() {
			this.modalShow = false
			this.changestatus = ''
			this.modalstatus = ''
			this.modalId = ''
		},
		async changeMappingStatus() {
			try {
				this.is_Loading = true
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateMappingStatus',
					'data': {
						"id": this.modalId,
						"status": this.modalstatus
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				if (result.data.status) {
					this.modalShow = false
					this.$alertify.success(result.data.msg)
					this.searchFilter()
				} else {
					this.$alertify.error(result.data.msg)
				}
				this.is_Loading = false
			} catch (err) {
				console.log(err);
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/pincodemapping/pincodemapping.component.js